import { render, staticRenderFns } from "./MenuStrict.vue?vue&type=template&id=ee32e45c&"
import script from "./MenuStrict.vue?vue&type=script&lang=js&"
export * from "./MenuStrict.vue?vue&type=script&lang=js&"
import style0 from "./MenuStrict.vue?vue&type=style&index=0&id=ee32e45c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports